import { get, update } from 'idb-keyval';
import { RecentSearchesStorage } from './types';

const STORAGE_KEY = 'BynderRecentSearches';
const MAX_RECENT_SEARCHES = 5;

export default class RecentSearchesRepository implements RecentSearchesStorage {
	public async getItems(): Promise<string[]> {
		const allItems = await get(STORAGE_KEY);

		if (!allItems) {
			return [];
		}

		return JSON.parse(allItems);
	}

	public async addItem(newSearch: string) {
		function onUpdate(oldValue: string | undefined): string {
			const allSearches: string[] = oldValue ? JSON.parse(oldValue) : [];
			const foundIndex = allSearches.findIndex(
				(item) => item.toLowerCase() === newSearch.toLowerCase(),
			);

			if (foundIndex !== -1) {
				allSearches.splice(foundIndex, 1);
			} else if (allSearches.length === MAX_RECENT_SEARCHES) {
				allSearches.pop();
			}

			allSearches.unshift(newSearch);

			return JSON.stringify(allSearches);
		}

		await update(STORAGE_KEY, onUpdate);
	}
}
